var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileFailedOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92676 7.32918C7.92676 5.07402 9.75493 3.24585 12.0101 3.24585H36.5101C37.0062 3.24585 37.479 3.45641 37.8109 3.82516L48.3109 15.4918C48.6001 15.8132 48.7601 16.2302 48.7601 16.6625V27.1625C48.7601 28.129 47.9766 28.9125 47.0101 28.9125C46.0436 28.9125 45.2601 28.129 45.2601 27.1625V17.3341L35.7307 6.74585H12.0101C11.6879 6.74585 11.4268 7.00702 11.4268 7.32918V49.3292C11.4268 49.6514 11.6879 49.9125 12.0101 49.9125H26.0101C26.9766 49.9125 27.7601 50.696 27.7601 51.6625C27.7601 52.629 26.9766 53.4125 26.0101 53.4125H12.0101C9.75494 53.4125 7.92676 51.5844 7.92676 49.3292V7.32918Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9393 34.0917C33.6227 33.4083 34.7308 33.4083 35.4142 34.0917L49.4142 48.0917C50.0976 48.7752 50.0976 49.8832 49.4142 50.5666C48.7308 51.25 47.6227 51.25 46.9393 50.5666L32.9393 36.5666C32.2559 35.8832 32.2559 34.7752 32.9393 34.0917Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4142 34.0917C50.0976 34.7752 50.0976 35.8832 49.4142 36.5666L35.4142 50.5666C34.7308 51.25 33.6227 51.25 32.9393 50.5666C32.2559 49.8832 32.2559 48.7752 32.9393 48.0917L46.9393 34.0917C47.6227 33.4083 48.7308 33.4083 49.4142 34.0917Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3434 3.24585C36.3099 3.24585 37.0934 4.02935 37.0934 4.99585V14.9125H47.0101C47.9766 14.9125 48.7601 15.696 48.7601 16.6625C48.7601 17.629 47.9766 18.4125 47.0101 18.4125H35.3434C34.3769 18.4125 33.5934 17.629 33.5934 16.6625V4.99585C33.5934 4.02935 34.3769 3.24585 35.3434 3.24585Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFailedOne);
export default __webpack_public_path__ + "static/media/file-failed-one.b27bc19a.svg";
export { ForwardRef as ReactComponent };